"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticateAndLoginRequest = void 0;
var AuthenticateAndLoginRequest = /** @class */ (function () {
    function AuthenticateAndLoginRequest(userId, password, returnUrl, retreiveUserInfo, saveUserId) {
        this.userId = userId;
        this.password = password;
        this.returnUrl = returnUrl;
        this.retreiveUserInfo = retreiveUserInfo;
        this.saveUserId = saveUserId;
    }
    return AuthenticateAndLoginRequest;
}());
exports.AuthenticateAndLoginRequest = AuthenticateAndLoginRequest;
//# sourceMappingURL=AuthenticateAndLoginRequest.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/models/request/AuthenticateAndLoginRequest.js
// module id = 584
// module chunks = 8